import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React, { createContext, useContext, useState } from "react";
import CheckSentProject from "../../components/CheckSentProject";
import GlobalHeader from "../../components/header";
import FirstStep from "../../components/NewProjectsSteps/FirstStep";
import SecondStep from "../../components/NewProjectsSteps/SecondStep";
import SnackAlert from "../../components/SnackAlert";
import useApi from "../../hooks/useApi";
import { useNavigate } from 'react-router-dom';
import useSnack from "../../hooks/useSnack";
import { buttonActionNewProject } from "../../styles";
import { validateDates, ValidateFirstStep, ValidateSecondStep, validateMinMaxIsValid } from "../../utils/validations";

export const NewProjectContext = createContext();

export const ButtonsActions = ({ last = false }) => {
  const {
    handlerNextStep,
    handlerPreviousStep,
    handlerOnCreateProject,
    isLoading,
    activeStep,
    newCreateData,
  } = useContext(NewProjectContext);
  return (
    <Box
      display="flex"
      justifyContent={activeStep !== 0 ? "space-between" : "right"}
      mt={4}
      mb={2}
    >
      {activeStep !== 0 ? (
        <Button
          variant="contained"
          sx={buttonActionNewProject}
          onClick={handlerPreviousStep}
        >
          {/* <ChevronRightIcon sx={{ transform: "scaleX(-1)" }} /> */}
          Regresar
        </Button>
      ) : (
        ""
      )}

      {last ? (
        <Button
          variant="contained"
          loading={isLoading}
          sx={{ color: "white" }}
          onClick={handlerOnCreateProject}
        >
          CREAR PROYECTO
        </Button>
      ) : (
        <Button
          variant="contained"
          sx={buttonActionNewProject}
          onClick={handlerNextStep}
        >
          SIGUIENTE
          <ChevronRightIcon />
        </Button>
      )}
    </Box>
  );
};

const steps = ["Datos Generales", "Detalles Proyecto"];

function NewProject() {
  const myDate = new Date();
  const [messageCheck, setMessageCheck] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [previewPicture, setPreviewPicture] = useState();
  const [dataNewProject, setDataNewProject] = useState();
  const navigate = useNavigate();
  const [newCreateData, setNewCreateData] = useState({
    photo_profile: [],
    gallery: [],
    name: "",
    name_business: "",
    information: "",
    min_investment: "",
    esti_profitability: "",
    objective: "",
    loans: "",
    initial_date: `${myDate.getFullYear()}-${String(
      myDate.getMonth() + 1
    ).padStart(2, "0")}-${String(myDate.getDate()).padStart(2, "0")}`,
    final_date: "",
    deadpoint: "",
    min_marketing: "",
    max_marketing: "",
    min_construction: "",
    max_construction: "",
    warranty_inmobiliaria: "",
    warranty_economica: "",
    min_offered_capital: "",
    max_offered_capital: "",
    min_stake: "",
    max_stake: "",
    min_return_investment: "",
    max_return_investment: "",
  });
  const [galleryPreview, setGalleryPreview] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // project

  // UTILS
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();

  const CreateProject = () => {
    setIsLoading(true);
    loadApi("project", true, "post", newCreateData, true)
      .then((response) => {
        showSnack(response.data.message, "success");
        setIsLoading(false);
        setTimeout(() => {
          navigate('/me/projects', { replace: true });
        }, 2000);
      })
      .catch((e) => {
        showSnack(e.message);
        setIsLoading(false);
      });
  };
  const handlerNextStep = async () => {
    let response = ValidateFirstStep(newCreateData);
    if (!response) {
      showSnack("Debes completar todos los campos");
      return;
    }

    if (activeStep === 0) {
      try {
        setIsLoading(true);

        await loadApi(
          `project/validate`,
          true,
          "post",
          {
            min_investment: newCreateData.min_investment,
            objective: newCreateData.objective,
            loans: newCreateData.loans,
          }
        );

      } catch (error) {
        showSnack(error.message || "An error occurred");
        return false;

      } finally {
        setIsLoading(false);
      }
    }

    const datesAreValid = validateDates(
      newCreateData.initial_date,
      newCreateData.final_date,
      showSnack
    );
    if (!datesAreValid) {
      return;
    }
    setActiveStep(activeStep + 1);
  };


  const handlerPreviousStep = () => {
    if (activeStep === 0) return;
    setActiveStep(activeStep - 1);
  };
  const handlerChangePreviewImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewCreateData({ ...newCreateData, photo_profile: file });
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewPicture(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handlerOnCreateProject = async () => {
    let response = ValidateSecondStep(newCreateData);
    if (!response) {
      showSnack("Debes completar todos los campos");
      return;
    }

    let minMaxIsValid = validateMinMaxIsValid(
      newCreateData.min_offered_capital,
      "Capital mínimo ofrecido",
      newCreateData.max_offered_capital,
      "Capital máximo ofrecido",
      showSnack
    );
    if (!minMaxIsValid) {
      return;
    }

    minMaxIsValid = validateMinMaxIsValid(
      newCreateData.min_return_investment,
      "Mínimo retorno de inversión",
      newCreateData.max_return_investment,
      "Máximo retorno de inversión",
      showSnack
    );
    if (!minMaxIsValid) {
      return;
    }

    minMaxIsValid = validateMinMaxIsValid(
      newCreateData.min_stake,
      "Participaciones mínimas a dar",
      newCreateData.max_stake,
      "Participaciones máximas a dar",
      showSnack
    );
    if (!minMaxIsValid) {
      return;
    }

    minMaxIsValid = validateMinMaxIsValid(
      newCreateData.min_marketing,
      "Minimo invertido marketing",
      newCreateData.max_marketing,
      "Máximo invertido marketing",
      showSnack
    );
    if (!minMaxIsValid) {
      return;
    }

    minMaxIsValid = validateMinMaxIsValid(
      newCreateData.min_construction,
      "Minimo invertido construcción",
      newCreateData.max_construction,
      "Máximo invertido construcción",
      showSnack
    );
    if (!minMaxIsValid) {
      return;
    }

    CreateProject();
  };

  return (
    <NewProjectContext.Provider
      value={{
        activeStep,
        handlerNextStep,
        handlerPreviousStep,
        previewPicture,
        handlerChangePreviewImage,
        dataNewProject,
        setDataNewProject,
        showSnack,
        handlerOnCreateProject,
        newCreateData,
        setNewCreateData,
        galleryPreview,
        setGalleryPreview,
        isLoading,
      }}
    >
      <GlobalHeader />
      <Stack
        sx={{
          minHeight: "100vh",
          width: { xs: "100vw", sm: "85vw", md: "80vw", lg: "72vw" },
          marginInline: "auto",
          pt: 2,
          px: { xs: 0, md: 4 },
          backgroundColor: { xs: "none", md: "white" },
        }}
      >
        <Stack px={2}>
          {messageCheck ? (
            <CheckSentProject />
          ) : (
            <>
              <Typography component="h1" variant="h4" mb={3}>
                Nuevo Proyecto
              </Typography>
              <Stepper activeStep={activeStep} sx={{ mb: 6 }}>
                {(steps || []).map((label, index) => {
                  return (
                    <Step key={index} sx={{ color: "white !important" }}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              {activeStep === 0 ? (
                <FirstStep />
              ) : activeStep === 1 ? (
                <SecondStep />
              ) : (
                ""
              )}
            </>
          )}
        </Stack>
      </Stack>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
      {/* <Footer /> */}
    </NewProjectContext.Provider>
  );
}

export default NewProject;
